<template>
  <font-awesome-icon
    icon="circle"
    :class="[value
      ? 'text-success'
      : 'text-danger'
    ]"
  />
</template>

<script>
export default {
  name: 'BooleanVal',
  props: {
    value: {
      required: true,
    },
  },
};
</script>

<style scoped>

</style>
